function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import List from '../../../components/list/List';
import text, { formatSqmArea, formatCurrency } from '../../../text';
import classNames from 'classnames';
import T from 'prop-types';
var getArea = function(details) {
    return (details === null || details === void 0 ? void 0 : details.area_in_sqm) ? formatSqmArea(details.area_in_sqm.toFixed()) : null;
};
var getDescription = function(displayName, details) {
    return (details === null || details === void 0 ? void 0 : details.area_in_sqm) ? text('productData', {
        product: displayName,
        area: getArea(details)
    }) : displayName;
};
var ChargeItem = function(props) {
    var displayName = props.displayName, details = props.details, price = props.price, quote = props.quote, discounts = props.discounts, fees = props.fees, _props_isApproximate = props.isApproximate, isApproximate = _props_isApproximate === void 0 ? false : _props_isApproximate, _props_areaIsAlignedMiddle = props.areaIsAlignedMiddle, areaIsAlignedMiddle = _props_areaIsAlignedMiddle === void 0 ? false : _props_areaIsAlignedMiddle, _props_hideArea = props.hideArea, hideArea = _props_hideArea === void 0 ? false : _props_hideArea;
    return /*#__PURE__*/ React.createElement("tbody", {
        className: "ChargeItem"
    }, /*#__PURE__*/ React.createElement(List.Item, _object_spread({
        className: classNames('charge', {
            isApproximate: isApproximate && price.base
        }),
        description: hideArea || areaIsAlignedMiddle ? displayName : getDescription(displayName, details),
        value: price.base ? formatCurrency(price.base, quote.currency.name, quote.currency.scale_factor, {}, true) : text('toBeConfirmed')
    }, areaIsAlignedMiddle && {
        midText: "Area: ".concat(getArea(details))
    })), !isEmpty(fees) && fees.map(function(fee, i) {
        return /*#__PURE__*/ React.createElement(List.Item, {
            key: i,
            description: fee.display_name,
            value: "".concat(formatCurrency(fee.price.total, quote.currency.name, quote.currency.scale_factor, {}, true)),
            midText: areaIsAlignedMiddle ? /*#__PURE__*/ React.createElement("span", null) : null
        });
    }), !isEmpty(discounts) && discounts.map(function(discount, i) {
        return /*#__PURE__*/ React.createElement(List.Item, {
            key: i,
            description: discount.display_name,
            value: "-".concat(formatCurrency(discount.price.discount, quote.currency.name, quote.currency.scale_factor, {}, true)),
            className: "discount font-pink pl-3 font-italic",
            midText: areaIsAlignedMiddle ? /*#__PURE__*/ React.createElement("span", null) : null
        });
    }));
};
ChargeItem.propTypes = {
    displayName: T.string,
    details: T.object,
    price: T.object,
    quote: T.object,
    discounts: T.array,
    fees: T.array,
    isApproximate: T.bool,
    areaIsAlignedMiddle: T.bool,
    hideArea: T.bool
};
export default ChargeItem;
